import { render, staticRenderFns } from "./DeleteAnnotationControl.vue?vue&type=template&id=32d3f1f4"
import script from "./DeleteAnnotationControl.vue?vue&type=script&lang=js"
export * from "./DeleteAnnotationControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports